<template>
    <div class="col-md-12 col-lg-12 col-xl-9">
        <div class="sport-menu-tabs-sec">

            <!-- ***withdrawal section start here*** -->

             <WalletHeader/>

            <section class="walletPage-wrap">
                <div class="container">
                    <div class="withdraw-sec">
                        <div class="input-field">
                            <div class="d-flex justify-content-between align-items-center">
                                <label class="form-label">{{ $t('withdraw-amount','Withdraw Amount')}}</label>
                                <span>{{ $t('withdraw-amount','Withdrawable Amount')}} : {{($auth.user?.balance || 0 - (+$store.getters.lockedEarnedData?.earnBonus || 0) + parseInt($auth.user?.expl || 0)).toFixed(2)}}</span>
                            </div>
                            <input class="form-control" type="number" v-model="amount" placeholder="Enter amount" @input="amount = $helper.sanitizeNumber(+amount, +walletData?.range?.maximum_withdrawal || 99999999)">
                            <div class="min-max-section">
                                <div class="min-max-con">
                                    <h6>{{$t('min', 'min')}} <span>{{ walletData?.range?.minimum_withdrawal ? walletData?.range?.minimum_withdrawal : 100 }}</span></h6>
                                </div>
                                <div class="min-max-icon">
                                    <img src="@/assets/images/min-max-icon.svg" alt="max" loading="lazy">
                                </div>
                                <div class="min-max-con">
                                    <h6>{{$t('max', 'max')}} <span>{{ walletData?.range?.maximum_withdrawal ? walletData?.range?.maximum_withdrawal : 100000}}</span></h6>
                                </div>
                            </div>
                            <!-- ****** for eroor text ***** -->
                            <!-- <div class="thm-error-text">
                                <div>
                                    <p class="wrong-color"></p>
                                </div>
                            </div> -->
                        </div>
                        <div class="thm-gradient-but deposit-amount-bx deposit-amount-btn">
                            <div class="first-row-box data_list_val">
                                <template v-if="walletData?.stake">
                                    <div class="small-box shortNum" v-if="walletData?.stake.stake1">
                                        <button class="btn" @click="amount = walletData?.stake.stake1">{{ walletData?.stake.stake1 }}</button>
                                    </div>
                                    <div class="small-box shortNum" v-if="walletData?.stake.stake2">
                                        <button class="btn" @click="amount = walletData?.stake.stake2">{{ walletData?.stake.stake2 }}</button>
                                    </div>
                                    <div class="small-box shortNum" v-if="walletData?.stake.stake3">
                                        <button class="btn" @click="amount = walletData?.stake.stake3">{{ walletData?.stake.stake3 }}</button>
                                    </div>
                                    <div class="small-box shortNum" v-if="walletData?.stake.stake4">
                                        <button class="btn" @click="amount = walletData?.stake.stake4">{{ walletData?.stake.stake4 }}</button>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="withdraw-btn d-flex gap-2">
                            <a href="#editModal" data-bs-toggle="modal" class="btnTheme-yellow w-50">
                                <span><img loading="lazy" src="@/assets/images/edit-icon.svg" alt="edit-icon"></span>
                                <span>{{$t('edit-stake', 'Edit Stake')}}</span>
                            </a>
                            <a :class="{'btn-disabled' : amount < walletData?.range?.minimum_withdrawal }" @click="walletWithdrawSubmitBtn()" class="btnTheme-yellow w-50">
                                <span>{{$t('submit', 'Submit')}}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
            <Support></Support>
        
    </div>
    <EditStakeModal @updateStakes="saveButtonClick" v-if="walletData" :stakes="walletData?.stake"></EditStakeModal>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import WalletHeader from '../components/WalletHeader.vue';
import Support from '@/shared/components/support/Support.vue';
import EditStakeModal from '../components/EditStakeModal.vue';
export default {
    name: 'WalletWithdraw',
    components: {
        EditStakeModal,
        Support,
        WalletHeader
    },
    data() {
        return {
            amount: null,
            walletData: null,
            chips: null
        }
    },
    mounted() {
        if (this.$route.query.walletData) {
            this.walletData = JSON.parse(this.$route.query.walletData)
        } else {
            this.getWalletLimitsServiceCall();
        }
    },
    methods: {
        getWalletLimitsServiceCall() {
            this.loading = true;
            this.$apiCall('get', 'GET_STAKES', null, 'wallet').then(response => {
                this.loading = false;
                this.walletData = null;
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0) {
                            this.showErrorModalFunc(response?.data?.debug[0]);
                        } else {
                            this.walletData = response?.data?.data;
                            if (!this.walletData?.stake) {
                                if (!this.walletData.stake) {
                                    this.walletData.stake = {}; // Initialize walletData if it is null or undefined
                                }
                                this.walletData.stake.stake1 = 100;
                                this.walletData.stake.stake2 = 500;
                                this.walletData.stake.stake3 = 1000;
                                this.walletData.stake.stake4 = 5000;
                            }
                        }
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    this.showErrorModalFunc(error[0]);
                }
            });
        },
        getBankDetailsServiceCall() {
            
            this.loading = true;
            api.get(apiName.BANK_DETAILS).then(response => {
                this.loading = false;
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0) {
                            this.$errorToast(response?.data?.debug[0])
                        }
                        else {
                            //this.showSuccessModalFunc(response.data.message);
                            this.bankDetailsList = response?.data?.data;
                        }
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    this.$errorToast(error[0])
                }
            });
        },
        walletSubmit() {
            if (this.amount == null || this.amount < this.walletData?.withdraw_limit) {
                this.showErrorModalFunc('Please enter amount greter than equal to ' + this.walletData?.withdraw_limit);
            }
        },
        clickOnWalletDeposit() {
            this.$router.push({ path: '/wallet-deposit', query: { walletData: JSON.stringify(this.walletData) } })
        },

        saveButtonClick(stakes) {
            this.walletData.stake = stakes;
        },

        walletWithdrawSubmitBtn() {
            if (!this.loading) {
                if (this.amount == null) {
					this.$errorToast('Please enter amount.');
				}
                else if(this.amount < (this.walletData?.range?.minimum_withdrawal || 100) || this.amount > (this.walletData?.range?.maximum_withdrawal || 100000)){
                    this.$errorToast(this.amount < (this.walletData?.range?.minimum_withdrawal || 100) ? this.$t('enter-amount-greater-than-equal','Please Enter Amount Greater Than Equal To ') + (this.walletData?.range?.minimum_withdrawal || 100)
                     : 'Please Enter Amount Less Than Equal To ' + (this.walletData?.range?.maximum_withdrawal || 100000))
                }
                else {
                    this.$router.push({ name: 'payment-method', query: { amount: this.amount } })
                }
            }
        },
        showErrorModalFunc(message) {
            this.$errorToast(message)
        },
        showSuccessModalFunc(message) {
            this.$successToast(message)
        },
    }

}
</script>

<style></style>